import { useState } from 'react';
import Running from './running';
import Setup from './setup';

const getTotalSeconds = (strTime) => {
  return strTime
    .split(':')
    .reduce((acc, curr) => Number(acc) * 60 + Number(curr));
};

const getTotalMinutes = (sec) => {
  return Math.floor(sec / 60);
};

const getPadString = (num) => {
  return String(num).padStart(2, '0');
};

const Timer = () => {
  const [setting, setSetting] = useState({
    totalTabata: 4,
    totalRound: 3,
    exerciseTime: '00:20',
    exerciseRestTime: '00:10',
    prepTime: '00:30',
    tabataRestTime: '00:30',
  });

  const getTotalWorkoutTime = () => {
    const exerciseTime = getTotalSeconds(setting.exerciseTime);
    const exerciseRestTime = getTotalSeconds(setting.exerciseRestTime);
    const prepTime = getTotalSeconds(setting.prepTime);
    const tabataRestTime = getTotalSeconds(setting.tabataRestTime);

    const totalExerciseTime =
      setting.totalTabata *
        setting.totalRound *
        (exerciseTime + exerciseRestTime) +
      setting.totalTabata * tabataRestTime +
      prepTime;

    const minutes = getPadString(getTotalMinutes(totalExerciseTime));
    const seconds = getPadString(totalExerciseTime % 60);

    return `${minutes}:${seconds}`;
  };

  return (
    <div>
      <Running
        setting={setting}
        setSetting={setSetting}
        getTotalWorkoutTime={getTotalWorkoutTime}
      />
      <Setup
        setting={setting}
        setSetting={setSetting}
        getTotalWorkoutTime={getTotalWorkoutTime}
      />
    </div>
  );
};

export default Timer;
